import React, { useEffect } from "react";
import { ThemeCard } from "../../components/ThemeCard";
import { allThemes } from "../../modules/themes";
import { Link } from "react-router-dom";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

export default function AcademyThemes() {
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Thèmes</h1>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Découvrez les thèmes MixMind. Commencez par le biais de confirmation pour tester l'expérience.
        </p>
      </header>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {allThemes.map((theme) => (
          <Link to={`/theme/${theme.id}`} key={theme.id} className="block">
            <ThemeCard theme={theme} />
          </Link>
        ))}
      </div>
      <Link to="/academy" className="text-sm text-blue-600 underline">
        Retour Academy
      </Link>
    </div>
  );
}
